export enum EmittEvent {
  downloadAppAlert = 'downloadAppAlert'
}
